import React from "react"
import { graphql } from "gatsby"
import styled, { css } from "styled-components"

import SEO from "../components/SEO"

import Layout from "../components/Layout"
import { Lede } from "../components/Typography"

import { H1 } from "../components/atoms/Headings"
import { Margin, Padding, pb } from "styled-components-spacing"
import breakpoint from "styled-components-breakpoint"
import { GatsbyImage } from "gatsby-plugin-image"
import { Slat } from "../components/template/Slat"
import LinkResolver from "../utils/linkResolver"

const Header = styled(Margin)`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-column-gap: 24px;

  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  ${pb(3)};

  ${breakpoint("sm")(
    () => css`
      grid-template-columns: 80px 1fr;
      ${pb(4)};
    `
  )}
`
const TemplateCreatorPageTemplate = ({ data, pageContext }) => {
  const { bio, name, featuredImage, internal } = data.contentfulPerson

  const seoNode = {
    title: `Templates created by ${name}`,
    description: bio.bio,
    pagePath: LinkResolver(internal.type, pageContext.slug),
  }

  return (
    <Layout>
      <SEO {...seoNode} />
      <Header>
        {featuredImage?.gatsbyImageData && (
          <GatsbyImage image={featuredImage.gatsbyImageData} />
        )}
        <div
          css={css`
            grid-column: 2 / 3;
          `}
        >
          <H1 mt={1} mb={1}>
            {name}
          </H1>
          <Lede>{bio.bio}</Lede>
        </div>
      </Header>
      <Padding bottom={4}>
        <Margin vertical={2}>
          <strong>Templates by {name}</strong>
        </Margin>
        {data.allContentfulTemplate.nodes.map((template, i) => (
          <Slat first={i === 0} key={template.slug} template={template} />
        ))}
      </Padding>
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    contentfulPerson(slug: { eq: $slug }) {
      name
      slug
      featuredImage {
        gatsbyImageData(
          layout: FIXED
          resizingBehavior: FILL
          width: 80
          height: 80
        )
      }
      internal {
        type
      }

      bio {
        bio
      }
    }

    allContentfulTemplate(
      filter: {
        createdBy: { elemMatch: { slug: { eq: $slug } } }
        title: { ne: "__schema__" }
      }
      sort: { fields: title }
    ) {
      nodes {
        ...ContentfulTemplateSlatFragment
      }
    }
  }
`

export default TemplateCreatorPageTemplate
